import { createContext, useContext, useRef, useEffect } from 'react';

const SocketContext = createContext(null);
const SIGNAL_URL = 'https://turn.lepb.fr:3004';

// Socket unique global — jamais détruit
let globalSocket = null;

export function SocketProvider({ children }) {
  const socketRef = useRef(null);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    if (!user) return;
    const userId = String(user._id || user.id);

    // Si déjà connecté, réutilise
    if (globalSocket?.connected) {
      socketRef.current = globalSocket;
      return;
    }

    import('socket.io-client').then(({ io }) => {
      if (globalSocket?.connected) {
        socketRef.current = globalSocket;
        return;
      }
      globalSocket = io(SIGNAL_URL, {
        transports: ['websocket'],
        reconnection: true,
        reconnectionDelay: 3000,
      });
      socketRef.current = globalSocket;
      globalSocket.on('connect', () => {
        globalSocket.emit('visio-register', { userId });
        globalSocket.emit('user-online', { userId });
        console.log('Socket global connecte:', globalSocket.id, 'userId:', userId);
      });
      globalSocket.on('reconnect', () => {
        globalSocket.emit('visio-register', { userId });
        globalSocket.emit('user-online', { userId });
      });
    });
    // PAS de cleanup — le socket reste en vie toute la session
  }, []);

  return (
    <SocketContext.Provider value={socketRef}>
      {children}
    </SocketContext.Provider>
  );
}

export function useSocket() {
  return useContext(SocketContext);
}
